import { render } from "./ParameterSelectionPage.vue?vue&type=template&id=4071f8f2&scoped=true&ts=true"
import script from "./ParameterSelectionPage.vue?vue&type=script&lang=ts"
export * from "./ParameterSelectionPage.vue?vue&type=script&lang=ts"

import "./ParameterSelectionPage.vue?vue&type=style&index=0&id=4071f8f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4071f8f2"]])

export default __exports__